import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../context/AppContext";
import ImageOrArt from "../components/ImageOrArt";
import { Reveal } from "../components/Reveal";

const CATEGORIES = ["All", "Field Faces", "Flags", "Mixed Media", "Works on Paper", "Special Projects"];

export default function Artwork() {
  const [works, setWorks] = useState([]);
  const [cat, setCat] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API}/artworks`, { params: cat === "All" ? {} : { category: cat } })
      .then(({ data }) => setWorks(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [cat]);

  return (
    <main className="pt-24 sm:pt-32" data-testid="artwork-page">
      <section className="container-x section-y">
        <p className="eyebrow mb-6">The Gallery</p>
        <h1 className="h-display mb-12" data-testid="artwork-headline">Artwork</h1>
        <div className="flex flex-wrap gap-2 mb-14" data-testid="artwork-filters">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`artwork-filter-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className={`font-display font-bold uppercase tracking-widest text-xs px-5 py-2.5 border transition-colors duration-300 ${
                cat === c ? "bg-[#FF1A1A] border-[#FF1A1A] text-white" : "border-border hover:border-[#FF1A1A] hover:text-[#FF1A1A]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
        {loading ? (
          <p className="text-muted-foreground font-mono-x text-sm" data-testid="artwork-loading">Loading gallery…</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {works.map((a, i) => (
              <Reveal key={a.id} delay={(i % 3) * 0.08}>
                <Link to={`/artwork/${a.id}`} className="group block" data-testid={`artwork-card-${a.id}`}>
                  <div className="relative overflow-hidden border border-border">
                    <div className="transition-transform duration-700 group-hover:scale-105">
                      <ImageOrArt image={a.image} seed={a.seed} className="w-full" />
                    </div>
                    <span
                      className={`absolute top-3 left-3 font-mono-x text-[10px] uppercase tracking-widest px-2 py-1 ${
                        a.availability === "Available" ? "bg-[#FF1A1A] text-white" : "bg-black/80 text-white border border-white/20"
                      }`}
                      data-testid={`artwork-status-${a.id}`}
                    >
                      {a.availability}
                    </span>
                  </div>
                  <div className="flex justify-between items-start mt-4">
                    <div>
                      <h3 className="font-display font-bold uppercase text-sm group-hover:text-[#FF1A1A] transition-colors">{a.title}</h3>
                      <p className="font-mono-x text-xs text-muted-foreground mt-1">{a.year} — {a.medium}</p>
                    </div>
                    {a.price > 0 && <span className="font-mono-x text-xs text-[#FF1A1A]">${a.price.toLocaleString()}</span>}
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </main>
  );
}
